module.exports = __webpack_public_path__ + "static/media/riq.6839c1c1.jpg";